import { useEffect } from "react";
import { useUI } from "../providers/MoleUIContext";
import { useAppSocket } from "../providers/AppSocketContext";
import { Util } from "../util/Util";

/**
 * Publishes the active task total (and optional line count) to the footer status bar.
 * Clears the status message on unmount or when disabled.
 */
export function useActiveTaskStatusTotal(
	total: number | null | undefined,
	itemCount?: number | null,
	enabled = true,
) {
	const { setStatusMessage, t } = useUI();
	const { appSettings } = useAppSocket();
	const currency = appSettings?.BIZ_CURRENCY?.value || "USD";

	useEffect(() => {
		if (!enabled || total == null || Number.isNaN(Number(total))) {
			return;
		}

		const formattedTotal = Util.formatCurrency(Number(total), currency);
		const message =
			itemCount != null
				? t("common:ui.labels.count", {
					num: Util.formatNumber(itemCount),
					total: formattedTotal,
				})
				: t("common:ui.labels.totalWithValue", {
					value: formattedTotal,
				});

		setStatusMessage(message);

		return () => {
			setStatusMessage(null);
		};
	}, [total, itemCount, enabled, currency, setStatusMessage, t]);
}
